// extracted by mini-css-extract-plugin
export default {"root":"PostcodePrompt-module-root","message":"PostcodePrompt-module-message"};